import { Link } from "@tanstack/react-router"
import type { ICollectionType } from "~/models/collection"
import { CollectionType } from "~/models/collection"
import { Tooltip } from "./Tooltip"
import { cn } from "~/utils/helpers"

type Props = {
  collectionId: number
  collectionName: string
  collectionType?: ICollectionType | string
  isGroup?: boolean
  className?: string
  onClick?: (e: React.MouseEvent) => void
}

export function CollectionLink({
  collectionId,
  collectionName,
  collectionType,
  isGroup = false,
  className,
  onClick,
}: Props) {
  const to =
    collectionType === CollectionType.Noos
      ? "/demand-planning/noos/$collectionId"
      : "/demand-planning/fashion/$collectionId"

  return (
    <Tooltip title={`Go to ${collectionName}`}>
      <Link
        className={cn("w-full", className)}
        onClick={(e) => {
          e.stopPropagation()
          onClick?.(e)
        }}
        to={to}
        params={{ collectionId: collectionId.toString() }}
        search={(prev) => ({ ...prev, isGroup })}
      >
        <span className="hover:underline">{collectionName}</span>
      </Link>
    </Tooltip>
  )
}
